module.exports = __webpack_public_path__ + "static/media/yogi-400.51bbfc6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yogi-400.png
// module id = 257
// module chunks = 0